import { call, put, takeLatest } from 'redux-saga/effects';
import {
  createBehalfBidProposal,
  deleteBidder,
  getBidderDetail,
  getBidderList,
  updateBidder,
} from '../../api/constlink';
import {
  deleteBidderAsync,
  DELETE_BIDDER,
  getBidderDetailAsync,
  getBidderListAsync,
  GET_BIDDER_DETAIL,
  GET_BIDDER_LIST,
  updateBidderAsync,
  UPDATE_BIDDER,
  createBehalfBidProposalAsync,
  CREATE_BEHALF_BID_PROPOSAL,
} from './actions';
import { Bidder } from './types';

function* getBidderListSaga(
  action: ReturnType<typeof getBidderListAsync.request>,
) {
  try {
    const bidders: Bidder[] = yield call(getBidderList, action.payload);
    yield put(getBidderListAsync.success(bidders));
  } catch (e: any) {
    yield put(getBidderListAsync.failure(e));
  }
}

function* updateBidderSaga(
  action: ReturnType<typeof updateBidderAsync.request>,
) {
  try {
    const bidder: Bidder = yield call(updateBidder, action.payload);
    yield put(updateBidderAsync.success(bidder));
  } catch (e: any) {
    yield put(updateBidderAsync.failure(e));
  }
}

function* deleteBidderSaga(
  action: ReturnType<typeof deleteBidderAsync.request>,
) {
  try {
    const bidderId: number = yield call(deleteBidder, action.payload);
    yield put(deleteBidderAsync.success(bidderId));
  } catch (e: any) {
    yield put(deleteBidderAsync.failure(e));
  }
}

function* getBidderDetailSaga(
  action: ReturnType<typeof getBidderDetailAsync.request>,
) {
  try {
    const bidder: Bidder = yield call(getBidderDetail, action.payload);
    yield put(getBidderDetailAsync.success(bidder));
  } catch (e: any) {
    yield put(getBidderDetailAsync.failure(e));
  }
}

function* createBehalfBidProposalSaga(
  action: ReturnType<typeof createBehalfBidProposalAsync.request>,
) {
  try {
    const bidder: Bidder = yield call(createBehalfBidProposal, action.payload);
    yield put(createBehalfBidProposalAsync.success(bidder));
  } catch (e: any) {
    yield put(createBehalfBidProposalAsync.failure(e));
  }
}

export function* biddersSaga() {
  yield takeLatest(GET_BIDDER_LIST, getBidderListSaga);
  yield takeLatest(UPDATE_BIDDER, updateBidderSaga);
  yield takeLatest(DELETE_BIDDER, deleteBidderSaga);
  yield takeLatest(GET_BIDDER_DETAIL, getBidderDetailSaga);
  yield takeLatest(CREATE_BEHALF_BID_PROPOSAL, createBehalfBidProposalSaga);
}
